<template>
  <section class="why-each-day">
    <b-container>
      <b-row>
        <b-col class="text-center">
          <div class="contents mx-auto">
            <h2 class="my-0">Each day may bring new demands.</h2>

            <p class="dark-text mb-0">
              ADHD, or attention deficit hyperactivity disorder, is a common mental health disorder that is seen in children, adolescents, and adults.
              For many people with ADHD, daily demands may start early and
              extend into the afternoon and evening. Each person may struggle
              with ADHD symptoms in their own&nbsp;way.
            </p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "WhyEachDay",
};
</script>
